import { useAppContext } from '../../Services/AppContext';
import SearchWorkplaceDoctorNoResults from '../SearchWorkplaceDoctor/SearchWorkplaceDoctorNoResults';
import SearchWorkplaceDoctorResult from '../SearchWorkplaceDoctor/SearchWorkplaceDoctorResult';
import SearchWorkplaceResult from '../SearchWorkplace/SearchWorkplaceResult';
import SearchWorkplaceNoResults from '../SearchWorkplace/SearchWorkplaceNoResults';
import { useState } from 'react';
import { useEffectAsync } from '../../helpers';
import apiClient from '../../Services/ApiClient';
import { gql } from '@apollo/client';
import { PROFILE_NAME_FRAGMENT, AVATAR_FRAGMENT } from '../UserInfo/UserData';
import * as React from 'react';
import Search from '../Search/Search';

export default function SearchWorkplaceMemberCombined({
	linkContinue,
	gqlParams,
}) {
	const { translation } = useAppContext();
	const [workplaceItems, setWorkplaceItems] = useState(null);
	const [workplaceMemberItems, setWorkplaceMemberItems] = useState(null);
	const [workplace, setWorkplace] = useState(null);
	const [activeRelations, setActiveRelations] = useState(null);
	const [fulltextWorkplace, setFulltextWorkplace] = useState('');
	const [fulltextMember, setFulltextMember] = useState('');
	const [refresh, setRefresh] = useState(null);

	const handleRefresh = () => {
		setRefresh(new Date());
	};

	const handleSearchWorkplace = text => {
		setFulltextWorkplace(text);
	};
	const handleSearchWorkplaceMember = text => {
		setFulltextMember(text);
	};

	const handleSelectWorkplace = workplace => {
		setWorkplace(workplace);
		setFulltextWorkplace('');
		setFulltextMember('');
	};

	// @ts-ignore
	const handleSelectWorkplaceMember = async workplaceMember => {
		await apiClient.post('/user-relations', {
			relationUserId: workplaceMember.user.id,
			workplaceId: workplaceMember.workplace.id,
		});
		handleSelectWorkplace(null);
		handleRefresh();
	};

	// @ts-ignore
	const handleUnselectWorkplaceMember = async workplaceMember => {
		await apiClient.delete('/user-relations/' + workplaceMember.id, {
			relationUserId: workplaceMember.user.id,
			workplaceId: workplaceMember.workplace.id,
		});
		handleRefresh();
	};

	const searchWorkplaceQuery = gql`
		query Workplaces($fulltext: String!, $patientId: UUID!, $type: String) {
			workplaces(fulltext: $fulltext, patientId: $patientId, type: $type) {
				data {
					id
					name
				}
			}
		}
	`;
	const searchMemberQuery = gql`
		${PROFILE_NAME_FRAGMENT}
		${AVATAR_FRAGMENT}
		query Doctors($fulltext: String!, $workplaceId: UUID) {
			caseDoctors(fulltext: $fulltext, workplaceId: $workplaceId) {
				data {
					id
					workplace {
						id
						caseDoctorDescription
					}
					user {
						id
						...avatar
						profile {
							...userName
						}
					}
				}
			}
		}
	`;
	const listUserRelationQuery = gql`
		${PROFILE_NAME_FRAGMENT}
		${AVATAR_FRAGMENT}
		query UserRelations {
			me {
				userRelations {
					id
					workplace {
						id
						caseDoctorDescription
					}
					relationUser {
						id
						...avatar
						profile {
							...userName
						}
					}
				}
			}
		}
	`;

	// @ts-ignore
	useEffectAsync(async () => {
		const result = await apiClient.graphql({
			query: listUserRelationQuery,
			fetchPolicy: 'network-only',
		});
		setActiveRelations(result?.data?.me?.userRelations || []);
	}, [refresh]);

	// @ts-ignore
	useEffectAsync(async () => {
		const result = await apiClient.graphql({
			query: searchWorkplaceQuery,
			variables: { fulltext: fulltextWorkplace, type: 'normal', ...gqlParams },
			fetchPolicy: 'network-only',
		});
		setWorkplaceItems(result?.data?.workplaces?.data || []);
	}, [fulltextWorkplace]);

	// @ts-ignore
	useEffectAsync(async () => {
		if (fulltextMember.length > 2 && workplace) {
			const result = await apiClient.graphql({
				query: searchMemberQuery,
				variables: {
					fulltext: fulltextMember,
					workplaceId: workplace.id,
					...gqlParams,
				},
				fetchPolicy: 'network-only',
			});
			setWorkplaceMemberItems(result?.data?.caseDoctors?.data || []);
		} else {
			setWorkplaceMemberItems(null);
		}
	}, [fulltextMember]);

	const workplaceItemsContent = workplaceItems?.length ? (
		workplaceItems.map((item, index) => (
			<SearchWorkplaceResult
				key={index}
				workplace={item}
				handleClick={handleSelectWorkplace}
			/>
		))
	) : (
		<SearchWorkplaceNoResults />
	);

	const workplaceMemberItemsContent = workplaceMemberItems?.length ? (
		workplaceMemberItems.map((item, index) => (
			<SearchWorkplaceDoctorResult
				key={index}
				workplaceMember={item}
				handleClick={handleSelectWorkplaceMember}
				hideFavoriteButton
			/>
		))
	) : (
		<SearchWorkplaceDoctorNoResults />
	);

	return (
		<>
			{activeRelations !== null &&
				activeRelations.map((item, index) => (
					<SearchWorkplaceDoctorResult
						key={index}
						workplaceMember={{ ...item, user: item.relationUser }}
						hideFavoriteButton
						showRemove
						handleClick={handleUnselectWorkplaceMember}
					/>
				))}
			{activeRelations !== null && <br />}
			{!workplace && (
				<Search
					resultContent={workplaceItems !== null ? workplaceItemsContent : null}
					handleSearch={handleSearchWorkplace}
					placeholder={
						translation['base.shared.enterWorkplaceNameWhichYouAreLookingFor']
					}
					label={'vyberte ambulanci'}
				/>
			)}
			{workplace && (
				<div className='form-group mt-2'>
					<div className={'col-form-label'}>
						<label>{'vyberte ambulanci'}</label>
					</div>
				</div>
			)}
			{workplace && (
				<SearchWorkplaceResult
					workplace={workplace}
					handleClick={() => handleSelectWorkplace(null)}
					showRemove
					showArrow={false}
				/>
			)}
			{workplace && (
				<Search
					marginTop={20}
					resultContent={
						workplaceMemberItems !== null ? workplaceMemberItemsContent : null
					}
					handleSearch={handleSearchWorkplaceMember}
					placeholder={
						translation['base.shared.enterSurnameOfDoctorWhichYouAreLookingFor']
					}
					label={'vyberte vašeho ošetřujícího lékaře'}
				/>
			)}
		</>
	);
}
